import cn from 'classnames';
import React, { useMemo } from 'react';
import BaseSlider from 'react-slick';
import type { Settings } from 'react-slick';

import { Arrow } from './Arrow';
import styles from './styles.module.scss';

import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

interface SlickButtonProps extends React.HTMLAttributes<HTMLSpanElement> {
  currentSlide?: number;
  slideCount?: number;
  buttonsClassName?: string;
}

const SlickButton = ({
  currentSlide: _currentSlide,
  slideCount: _slideCount,
  children,
  className = '',
  buttonsClassName,
  ...props
}: SlickButtonProps) => (
  <span style={{ display: 'inline-block' }} {...props} className={cn(className, buttonsClassName)}>
    {children}
  </span>
);

const DEFAULT_SETTINGS: Settings = {
  dots: true,
  slidesToShow: 1,
  autoplay: false,
  arrows: true,
  infinite: true,
  dotsClass: styles.dots,
};

interface SliderProps extends React.ComponentProps<typeof BaseSlider> {
  className?: string;
  buttonsClassName?: string;
}

export const Slider = ({ className, buttonsClassName, ...props }: SliderProps) => {
  const defaultSettings = useMemo(
    () => ({
      ...DEFAULT_SETTINGS,

      prevArrow: (
        <SlickButton buttonsClassName={buttonsClassName}>
          <Arrow className={styles.arrow} />
        </SlickButton>
      ),
      nextArrow: (
        <SlickButton buttonsClassName={buttonsClassName}>
          <Arrow className={cn(styles.arrow, styles['arrow--next'])} />
        </SlickButton>
      ),
    }),
    [buttonsClassName],
  );

  return <BaseSlider className={cn(className, styles.slider)} {...defaultSettings} {...props} />;
};
